import { useParams } from "react-router-dom";
import Header from "../components/Header";
import { t } from "../app/Translate";
import Footer from "../components/Footer";
import FormRegister from "../components/FormRegister";

const Register = () => {     
    const {isocode}: any = useParams();   
    const {id}: any = useParams();   

    return(
        <>
            <Header isocode={isocode} active=""/>
            <main className="main-content">
                <section className="header-plans" style={{paddingLeft:"50px"}}>
                    <div className="row" style={{paddingTop:"130px",textAlign:"center"}}>
                        <div className="col-md-1"></div>
                        <div className="col-md-10 bannertext1">
                            {t("register.title")}
                            <div className="bannertext2" style={{paddingRight:"50px"}} dangerouslySetInnerHTML={{ __html: t("register.subtitle") }} />                             
                        </div>                          
                        <div className="col-md-1"></div>                      
                    </div>                           
                </section>
                <FormRegister isocode={isocode} id={id} />        
               
                <Footer isocode={isocode} />  
            </main>
        </>
    )
}

export default Register;